import Vue from "vue";
import VueRouter from "vue-router";
import store from "@store";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  /*
   * Use the HTML5 history API (i.e. normal-looking routes)
   * instead of routes with hashes (e.g. example.com/#/about).
   * This may require some server configuration in production:
   * https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
   */
  mode: "history",
  /*
   * Simulate native-like scroll behavior when navigating to a new
   * route and using back/forward buttons.
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeResolve((routeTo, routeFrom, next) => {
  const requiresUserToBeLoggedIn = routeTo.matched.some(
    (record) => record.meta.requiresUserToBeLoggedIn
  );

  const requiresCompanyToBeLoggedIn = routeTo.matched.some(
    (record) => record.meta.requiresCompanyToBeLoggedIn
  );

  const userIsLoggedIn = store.getters["user/userIsLoggedIn"];
  const companyIsLoggedIn = store.getters["company/companyIsLoggedIn"];

  if (requiresUserToBeLoggedIn && !userIsLoggedIn) {
    next({ name: "login" });
  } else if (requiresCompanyToBeLoggedIn && !companyIsLoggedIn) {
    next({ name: "user" });
  } else if (routeTo.name === "login" && userIsLoggedIn) {
    next({ name: "user" });
  } else {
    next();
  }
});

export default router;
